module.exports = "//static.hsappstatic.net/LoginUI/static-1.7023/img/google-logo.png"